import { useI18nContext } from '@ecg-marktplaats/js-react-i18n';
import { Icon, TextRegular } from '@hz-design-system/web-ui';

import Classes from './ListingTrustIndicator.module.scss';

type ListingTrustIndicatorProps = {
  trustIndicator: { value?: string; key: string; logo?: string };
};

const ListingTrustIndicator = ({ trustIndicator }: ListingTrustIndicatorProps) => {
  const { t } = useI18nContext();
  const label = t(`trustIndicator.${trustIndicator.key}`);

  return (
    <div className={Classes.root}>
      <Icon name="checkmark" color="text-warning" />
      <TextRegular strong className={Classes.text}>
        {trustIndicator.logo ? trustIndicator.value : label}
      </TextRegular>
    </div>
  );
};

export default ListingTrustIndicator;
